<template>
  <b-navbar-nav class="ml-auto">
    <b-nav-item-dropdown class="gggggg" right no-caret>
      <template slot="button-content">
        <font-awesome-icon icon="sliders-h" class="mr-3"></font-awesome-icon>
        <span>Filters</span>
      </template>
      <filter-dropdown
        :filterData="filterData.propertyFilterList"
        :categoryId="categoryId"
        @applyFilter="applyFilter"
      ></filter-dropdown>
    </b-nav-item-dropdown>

    <!--<b-nav-item-dropdown right no-caret>-->
    <!--&lt;!&ndash; Using 'button-content' slot &ndash;&gt;-->
    <!--<template slot="button-content">-->
    <!--<span>Syllabus</span>-->
    <!--<font-awesome-icon icon="angle-down"></font-awesome-icon>-->
    <!--</template>-->
    <!--<filter-dropdown :filterData="syllabus"></filter-dropdown>-->
    <!--</b-nav-item-dropdown>-->

    <!--<b-nav-item-dropdown right no-caret>-->
    <!--&lt;!&ndash; Using 'button-content' slot &ndash;&gt;-->
    <!--<template slot="button-content">-->
    <!--<span>Standard</span>-->
    <!--<font-awesome-icon icon="angle-down"></font-awesome-icon>-->
    <!--</template>-->
    <!--<filter-dropdown :filterData="standard"></filter-dropdown>-->
    <!--</b-nav-item-dropdown>-->
  </b-navbar-nav>
</template>

<script>
import FilterDropdown from "../Filters/FilterDropdown";
export default {
  name: "filterBar",
  components: { FilterDropdown },
  data() {
    return {
      standard: [
        {
          heading: "Standard",
          data: [
            {
              item: "10th standard",
              count: 17
            },
            {
              item: "9th standard",
              count: 25
            },
            {
              item: "8th standard",
              count: 9
            },
            {
              item: "7th standard",
              count: 11
            },
            {
              item: "6th standard",
              count: 15
            },
            {
              item: "5th standard",
              count: 4
            }
          ]
        }
      ],
      syllabus: [
        {
          heading: "Syllabus",
          data: [
            {
              item: "kerala",
              count: 45
            },
            {
              item: "CBSE",
              count: 15
            },
            {
              item: "ICSE",
              count: 6
            },
            {
              item: "IBO",
              count: 5
            }
          ]
        }
      ],
      filterMain: [
        {
          heading: "Sub Category",
          data: [
            {
              item: "science",
              count: 45
            },
            {
              item: "test prep",
              count: 15
            },
            {
              item: "engineering",
              count: 9
            },
            {
              item: "online education",
              count: 11
            },
            {
              item: "other & academics",
              count: 25
            },
            {
              item: "physics",
              count: 10
            },
            {
              item: "maths",
              count: 8
            }
          ]
        },
        {
          heading: "Price",
          data: [
            {
              item: "paid",
              count: 420
            },
            {
              item: "Free",
              count: 2
            }
          ]
        },
        {
          heading: "Language",
          data: [
            {
              item: "Malayalam",
              count: 3510
            },
            {
              item: "English",
              count: 120
            }
          ]
        }
      ]
    };
  },
  methods: {
    applyFilter(courseData) {
      this.$emit("applyFilter", courseData);
    }
  },
  props: {
    filterData: Object,
    categoryId: String
  }
};
</script>

<style></style>
